var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":[10, 30, 50, 100],"page-size":_vm.pageSize,"layout":_vm.layout,"total":_vm.list.length},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }